import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts';

const Engagement = ({ data, chartName }) => {
    const [trendData, setTrendData] = useState([]);

    useEffect(() => {
        if (data) {
            setTrendData(data)
        }
    }, [data]);

    const categories = trendData.length ? trendData.map((item) => item.weekday) : [];
    const seriesData = trendData.length ? trendData.map((item) => item.count) : [];

    const options = {
        chart: {
            type: 'area',
            zoom: { enabled: false },
            toolbar: { show: false },
        },
        xaxis: {
            categories: categories,
            labels: {
                style: {
                    fontSize: '12px',
                    fontWeight: 400,
                    colors: ['#667085', '#667085', '#667085', '#667085', '#667085', '#667085',],
                },
                offsetX: 0,
                offsetY: 5,
                rotate: -45,
            },
        },
        yaxis: {
            labels: {
                show: true,
                showDuplicates: false,
                align: 'right',
                minWidth: 0,
                maxWidth: 160,
                style: {
                    colors: ['#667085'],
                    fontSize: '15px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                },
                offsetX: -15,
                offsetY: 0,
                rotate: 0,
            },
        },
        zoom: {
            enabled: false,
            autoScaleYaxis: false,
        },
        colors: ['#42973F'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                shadeIntensity: 1,
                gradientToColors: ['rgba(66, 151, 63, 0)'],
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 0,
                stops: [0, 95],
            },
        },
        stroke: {
            width: 2,
            curve: 'smooth',
        },
    };

    return (
        <div className='shadow-custom rounded-3xl p-5 w-full lg:w-1/3'>
            <p className='text-base font-semibold text-black mb-6'>{chartName}</p>
            <Chart
            className="mt-7"
                options={options}
                series={[{ name: "Trend", data: seriesData }]}
                type="area"
                width="100%"
                height="100%"
            />
        </div>
    )
}

export default Engagement